export const insertIntoArray = ({
  existingProducts,
  newProducts,
  insertionIndex = 0
}) => [
  ...existingProducts.slice(0, insertionIndex),
  ...newProducts,
  ...existingProducts.slice(insertionIndex)
];
